import { useState } from 'react';
import { Button } from '@nazka/nazka.mapframe.components';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-solid-svg-icons';

import UnactivatedMobilityField from '@App/components/EditMobilityOffer/UnactivatedMobilityField/UnactivatedMobilityField';
import ActivatedMobilityField from '@App/components/EditMobilityOffer/ActivatedMobilityField/ActivatedMobilityField';

import { fieldIsActivated } from './transfer-list.utils';

import './transfer-list.styl';

function TransferList({
  fields,
  mobilityOffer,
  setMobilityOffer,
  isAdmin,
}) {
  const [selectedUnactivatedFields, setSelectedUnactivatedFields] = useState([]);
  const [selectedActivatedFields, setSelectedActivatedFields] = useState([]);

  const unactivatedFields = fields.filter(field => !fieldIsActivated(field)).sort((f1, f2) => f1.order - f2.order);
  const activatedFields = fields.filter(field => fieldIsActivated(field)).sort((f1, f2) => f1.order - f2.order);

  return (
    <div className="transfer-list">
      <div className="transfer-list__container">
        <ul>
          {unactivatedFields.map((field) => {
            return (
              <UnactivatedMobilityField
                key={field.name}
                field={field}
                onClick={() => {
                  if (selectedUnactivatedFields.find(f => f.name === field.name)) {
                    setSelectedUnactivatedFields(selectedUnactivatedFields.filter(f => f.name !== field.name));
                  } else {
                    setSelectedUnactivatedFields([...selectedUnactivatedFields, field]);
                  }
                }}
                selected={selectedUnactivatedFields.find(f => f.name === field.name)}
              />
            );
          })}
        </ul>
      </div>
      <div className="transfer-list__buttons">
        <Button
          layout="outlined"
          icon={faArrowRight}
          disabled={!selectedUnactivatedFields.length}
          onClick={() => {
            if (selectedUnactivatedFields.length) {
              const nextMobilityOffer = { ...mobilityOffer };

              selectedUnactivatedFields.forEach((field) => {
                if (field.dataType === 'boolean') {
                  nextMobilityOffer[field.name] = true;
                }

                if (field.fieldType === 'drop-down') {
                  const [firstKey] = Object.keys(field.enum);
                  nextMobilityOffer[field.name] = firstKey;
                }
              });

              setMobilityOffer(nextMobilityOffer);
            }

            setSelectedUnactivatedFields([]);
          }}
        />
        <Button
          layout="outlined"
          icon={faArrowLeft}
          disabled={!selectedActivatedFields.length}
          onClick={() => {
            if (selectedActivatedFields.length) {
              const nextMobilityOffer = { ...mobilityOffer };

              selectedActivatedFields.forEach((field) => {
                nextMobilityOffer[field.name] = field.dataType === 'boolean' ? false : null;
              });

              setMobilityOffer(nextMobilityOffer);
            }

            setSelectedActivatedFields([]);
          }}
        />
      </div>
      <div className="transfer-list__container">
        <ul>
          {activatedFields.map((field) => {
            return (
              <ActivatedMobilityField
                key={field.name}
                field={field}
                onClick={() => {
                  if (selectedActivatedFields.find(f => f.name === field.name)) {
                    setSelectedActivatedFields(selectedActivatedFields.filter(f => f.name !== field.name));
                  } else {
                    setSelectedActivatedFields([...selectedActivatedFields, field]);
                  }
                }}
                showSupplements={isAdmin}
                selected={selectedActivatedFields.find(f => f.name === field.name)}
                onUpdateField={(name, value) => {
                  if (mobilityOffer) {
                    const nextMobilityOffer = { ...mobilityOffer };
                    nextMobilityOffer[name] = value;
                    setMobilityOffer(nextMobilityOffer);
                  }
                }}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default TransferList;